import React from 'react';

import { Box, Typography } from '@mui/material';

import PageSubheader from '~/components/Common/Elements/PageSubheader';

import type { TagType } from '~/consts/tags';

import BulkTagApply from './BulkTagApply';
import TagForm from './TagForm';
import TagsDataGrid from './TagsDataGrid';
import type { MarketingVerticalConfig } from './verticalConfig';

type Props = {
  title: string;
  tags: Array<App.MarketingTag>;
  type: TagType;
  vertical: MarketingVerticalConfig;
  onCreateTag: (type: TagType, name: string) => Promise<App.MarketingTag>;
  onDeleteTag: (type: TagType, id: number) => Promise<void>;
  onUpdateTag: (type: TagType, id: number, name: string) => Promise<void>;
};

export default function TagsComponent({ title, tags, type, vertical, onCreateTag, onDeleteTag, onUpdateTag }: Props) {
  return (
    <Box>
      <PageSubheader title={title} />

      <Typography variant="body1" fontSize={16} color="GrayText">
        Please allow up to one hour for changes to come into effect.
      </Typography>

      <Box mt={4}>
        <TagForm type={type} onCreateTag={onCreateTag} />
      </Box>

      <Box mt={4}>
        <BulkTagApply tags={tags} tagType={type} vertical={vertical} />
      </Box>

      <Box mt={4}>
        <TagsDataGrid tags={tags} type={type} onDeleteTag={onDeleteTag} onUpdateTag={onUpdateTag} />
      </Box>
    </Box>
  );
}
